"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";
export default function WhatOurClientsSay() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const testimonials = [{
    id: 1,
    description: "We selected KS Luxury Renovations to transform our rundown Zygi apartment into a modern, boutique-style getaway, and we couldn't be happier with the result. Kostas's work is incredibly detailed and thoughtfully planned. The team delivered exactly what was promised, on time and under budget, which is rare in renovations. A huge thank you to Kostas and the boys for their outstanding work. Highly recommended.",
    name: "George\n",
    title: "Project Location: Zygi   I   Project: Apartment Renovation\nProject duration: 2 Month"
  }, {
    id: 2,
    description: "I had a great experience working with KS Luxury Renovations on my office renovation. From the very beginning, they were professional and easy to communicate with. The team was reliable, respectful of the workspace, and kept the site clean and organized. The project was completed on time and exceeded my expectations. I would absolutely recommend this contractor to anyone looking for high-quality renovation work.",
    name: "Myria\n\n",
    title: "Project Location: Pentadromo  I   Project: Office Renovation\nProject duration: 6 weeks"
  }, {
    id: 3,
    description: "As the architect who designed and project-managed this home, I can confidently say that collaborating with KS Luxury Renovations was a truly professional experience from start to finish. The team executed the design with great precision and respect, maintaining clear communication and transparency throughout the project , even when challenges such as weather delays and supply issues arose. The quality of workmanship and attention to detail were outstanding, and the final result fully aligned with the architectural vision. I would wholeheartedly recommend KS Luxury Renovations to architects, developers, and private clients building in Cyprus.",
    name: "Ana Boron\n\n",
    title: "Architect, Limassol / Dubai\nProject Location: Limassol Marina  I   Project: Home Renovation\nProject duration: 5 months"
  }];
  return <section id="whatourclientssay" ref={sectionRef} className="py-16 px-4 !text-[rgba(139,110,76,0.3215686274509804)] !bg-[rgba(139,110,76,0.16470588235294117)] md:py-24 md:px-8">
      <div className="max-w-7xl mx-auto">
        <p className="text-sm font-normal text-center mb-4 tracking-wider !text-[hsl(32,29%,42%)]">TESTIMONIALS</p>
        <h2 className="font-display text-center mb-12 text-foreground transition-all duration-500 opacity-100 translate-y-0 !font-bold !text-5xl md:mb-8">Client Experience</h2>
        <p className="text-center max-w-2xl mx-auto mb-12 text-muted-foreground leading-relaxed !text-lg">Our clients value our attention to detail, transparency, and ability to deliver exactly what was promised — without compromise.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, i) => {
          const {
            ref: cardRef,
            isVisible: cardVisible
          } = useRevealOnScroll({
            once: true,
            threshold: 0.2
          });
          return <div key={testimonial.id} data-index={i} ref={cardRef} className={`transition-all duration-500 ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: cardVisible ? `${i * 100}ms` : "0ms"
          }}>
                <Card className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 h-full hover-lift border border-border shadow-soft !bg-[hsl(0,0%,100%)]">
                  <CardContent className="flex flex-col h-full justify-between gap-6">
                    <div className="flex-1">
                      <Quote className="text-[#a03223] mb-4 size-8" />
                      <p className="text-foreground leading-relaxed !text-sm">
                        {testimonial.description}
                      </p>
                    </div>
                    <div className="border-t border-border pt-4">
                      <p className="font-display font-semibold text-foreground text-lg">
                        {testimonial.name}
                      </p>
                      <p className="text-muted-foreground text-sm mt-1">
                        {testimonial.title}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}